// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Textarea-module__root--zUOvc > textarea {
  box-sizing: border-box;
  position: relative;
  display: flex;
  width: 100%;
  height: 132px;
  align-items: flex-start;
  padding: 10px 12px;
  border-radius: 6px;
  background-color: #fff;
  color: #1a1a1a;
  font-size: 0.875rem; /* 14px */
  font-weight: 400;
  line-height: 1.5833;
}

.Textarea-module__root--zUOvc > textarea::placeholder {
  color: #999;
  opacity: 1;
}

.Textarea-module__variant-soft--mXqWu > textarea {
  padding: 16px;
  border: 1px solid #c9c3ba;
  border-radius: 4px;
  background-color: #fff4df;
  color: #1a1a1a;
  font-size: 0.9375rem; /* 15px */
  line-height: normal;
}

.Textarea-module__variant-soft--mXqWu > textarea::placeholder {
  color: #888;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Textarea/Textarea.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,oBAAoB,EAAE,SAAS;EAC/B,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".root > textarea {\n  box-sizing: border-box;\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: 132px;\n  align-items: flex-start;\n  padding: 10px 12px;\n  border-radius: 6px;\n  background-color: #fff;\n  color: #1a1a1a;\n  font-size: 0.875rem; /* 14px */\n  font-weight: 400;\n  line-height: 1.5833;\n}\n\n.root > textarea::placeholder {\n  color: #999;\n  opacity: 1;\n}\n\n.variant-soft > textarea {\n  padding: 16px;\n  border: 1px solid #c9c3ba;\n  border-radius: 4px;\n  background-color: #fff4df;\n  color: #1a1a1a;\n  font-size: 0.9375rem; /* 15px */\n  line-height: normal;\n}\n\n.variant-soft > textarea::placeholder {\n  color: #888;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Textarea-module__root--zUOvc`,
	"variant-soft": `Textarea-module__variant-soft--mXqWu`
};
export default ___CSS_LOADER_EXPORT___;
